/**
 * Créditos / abonos desde el POS.
 */

function moneyUsd(n) {
	return `$${parseFloat(n || 0).toFixed(2)}`;
}

function moneyBs(n) {
	return `Bs. ${parseFloat(n || 0).toFixed(2)}`;
}

function getPaymentMethodsForAbono(win) {
	const list = Array.isArray(win.POSKN_PAYMENT_METHODS) ? win.POSKN_PAYMENT_METHODS : [];
	return list.filter((pm) => pm && pm.id && String(pm.id).toLowerCase() !== 'credito');
}

function resolveMethodCurrency(win, methodId) {
	const methods = getPaymentMethodsForAbono(win);
	const found = methods.find((pm) => String(pm.id) === String(methodId));
	if (found && found.currency) {
		return String(found.currency).toUpperCase() === 'BS' ? 'BS' : 'USD';
	}
	if (win.posMetodosPagoMoneda && Object.prototype.hasOwnProperty.call(win.posMetodosPagoMoneda, methodId)) {
		return String(win.posMetodosPagoMoneda[methodId]).toUpperCase() === 'BS' ? 'BS' : 'USD';
	}
	const id = String(methodId || '').toLowerCase();
	if (id.indexOf('-bs') >= 0 || id.indexOf('_bs') >= 0) return 'BS';
	return 'USD';
}

export function attachCreditsPosGlobals(win, $) {
	win.posknCreditsCache = win.posknCreditsCache || [];

	win.abrirModalCreditos = function abrirModalCreditos() {
		const $modal = $('#modal-creditos-pos');
		if (!$modal.length) {
			win.mostrarNotificacion('Modal de créditos no disponible', 'error');
			return;
		}
		$('#creditos-pos-buscar').val('');
		$modal.css('display', 'flex');
		win.cargarCreditosPos();
		setTimeout(() => {
			const input = document.getElementById('creditos-pos-buscar');
			if (input) input.focus();
		}, 80);
	};

	win.cerrarModalCreditos = function cerrarModalCreditos() {
		$('#modal-creditos-pos').hide();
		$('#modal-abono-credito').hide();
	};

	win.cargarCreditosPos = function cargarCreditosPos(search) {
		const $lista = $('#creditos-pos-lista');
		$lista.html('<div style="padding:20px;text-align:center;color:#666;">Cargando créditos...</div>');
		const tiendaId =
			win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id
				? parseInt(win.posknTiendaSeleccionada.id, 10)
				: 0;
		$.ajax({
			url: 'pos-ajax.php',
			method: 'POST',
			dataType: 'json',
			cache: false,
			timeout: 25000,
			data: {
				action: 'poskn_creditos_pendientes',
				nonce: win.posNonce || '',
				tienda_id: tiendaId || 0,
				search: search || '',
			},
		})
			.done((res) => {
				if (!res || !res.success) {
					const msg = (res && res.data) || 'No se pudieron cargar los créditos';
					$lista.html(`<div style="padding:16px;color:#b32d2e;">${msg}</div>`);
					return;
				}
				const credits = (res.data && res.data.credits) || [];
				win.posknCreditsCache = credits;
				win.renderCreditosPosLista(credits);
			})
			.fail(() => {
				$lista.html('<div style="padding:16px;color:#b32d2e;">Error de conexión al cargar créditos.</div>');
			});
	};

	win.renderCreditosPosLista = function renderCreditosPosLista(credits) {
		const $lista = $('#creditos-pos-lista');
		if (!credits || !credits.length) {
			$lista.html(
				'<div style="padding:24px;text-align:center;color:#666;">No hay créditos pendientes.</div>'
			);
			return;
		}
		const rows = credits
			.map((c) => {
				const doc = c.customer_document ? ` · Doc: ${c.customer_document}` : '';
				const phone = c.customer_phone ? ` · Tel: ${c.customer_phone}` : '';
				return `
				<div class="credito-pos-row" data-order-id="${c.order_id}" style="border:1px solid #e5e7eb;border-radius:8px;padding:12px;margin-bottom:10px;background:#fff;">
					<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;flex-wrap:wrap;">
						<div style="min-width:0;flex:1;">
							<div style="font-weight:700;font-size:14px;">${c.customer_name || 'Cliente'}</div>
							<div style="font-size:12px;color:#666;margin-top:2px;">Pedido #${c.order_number || c.order_id}${doc}${phone}</div>
							<div style="font-size:11px;color:#888;margin-top:2px;">${c.date || ''}</div>
						</div>
						<div style="text-align:right;">
							<div style="font-size:11px;color:#666;">Saldo</div>
							<div style="font-weight:700;color:#c62828;font-size:15px;">${moneyUsd(c.remaining)}</div>
							<div style="font-size:12px;color:#1565c0;">${moneyBs(c.remaining_bs)}</div>
						</div>
					</div>
					<button type="button" class="btn-agregar credito-pos-abonar-btn" data-order-id="${c.order_id}" style="width:100%;margin-top:10px;padding:10px;font-size:13px;">Registrar abono</button>
				</div>`;
			})
			.join('');
		$lista.html(rows);
	};

	win.abrirModalAbonoCredito = function abrirModalAbonoCredito(orderId) {
		const credit = (win.posknCreditsCache || []).find((c) => parseInt(c.order_id, 10) === parseInt(orderId, 10));
		if (!credit) {
			win.mostrarNotificacion('No se encontró el crédito seleccionado', 'error');
			return;
		}
		const methods = getPaymentMethodsForAbono(win);
		const $sel = $('#abono-metodo');
		$sel.empty();
		if (!methods.length) {
			$sel.append('<option value="">Sin métodos configurados</option>');
		} else {
			methods.forEach((pm) => {
				const cur = String(pm.currency || 'USD').toUpperCase() === 'BS' ? 'Bs' : 'USD';
				$sel.append(
					`<option value="${pm.id}" data-currency="${String(pm.currency || 'USD').toUpperCase() === 'BS' ? 'BS' : 'USD'}">${pm.name || pm.id} (${cur})</option>`
				);
			});
		}
		$('#abono-order-id').val(credit.order_id);
		$('#abono-cliente-nombre').text(credit.customer_name || 'Cliente');
		$('#abono-pedido-info').text(`Pedido #${credit.order_number || credit.order_id}`);
		$('#abono-saldo-usd').text(moneyUsd(credit.remaining));
		$('#abono-saldo-bs').text(moneyBs(credit.remaining_bs));
		$('#abono-monto').val('');
		$('#abono-referencia').val('');
		win.actualizarMonedaAbonoCredito();
		$('#modal-abono-credito').css('display', 'flex');
		setTimeout(() => {
			const input = document.getElementById('abono-monto');
			if (input) input.focus();
		}, 80);
	};

	win.actualizarMonedaAbonoCredito = function actualizarMonedaAbonoCredito() {
		const methodId = $('#abono-metodo').val();
		const currency = resolveMethodCurrency(win, methodId);
		$('#abono-currency').val(currency);
		$('#abono-moneda-label').text(currency === 'BS' ? 'Monto (Bs)' : 'Monto (USD)');
		$('#abono-monto').attr('placeholder', currency === 'BS' ? '0.00 Bs' : '0.00 USD');
	};

	win.confirmarAbonoCredito = function confirmarAbonoCredito() {
		const orderId = parseInt($('#abono-order-id').val(), 10);
		const amount = parseFloat($('#abono-monto').val());
		const method = $('#abono-metodo').val();
		const currency = $('#abono-currency').val() || resolveMethodCurrency(win, method);
		const referencia = ($('#abono-referencia').val() || '').trim();

		if (!orderId) {
			win.mostrarNotificacion('Pedido inválido', 'error');
			return;
		}
		if (!method) {
			win.mostrarNotificacion('Selecciona un método de pago', 'warning');
			return;
		}
		if (!(amount > 0)) {
			win.mostrarNotificacion('Ingresa un monto válido', 'warning');
			return;
		}

		const $btn = $('#btn-confirmar-abono-credito');
		$btn.prop('disabled', true).text('Guardando...');

		$.ajax({
			url: 'pos-ajax.php',
			method: 'POST',
			dataType: 'json',
			cache: false,
			timeout: 30000,
			data: {
				action: 'poskn_creditos_abonar',
				nonce: win.posNonce || '',
				order_id: orderId,
				amount,
				payment_method: method,
				currency,
				referencia,
				tienda_id:
					win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id
						? parseInt(win.posknTiendaSeleccionada.id, 10)
						: 0,
			},
		})
			.done((res) => {
				if (!res || !res.success) {
					const msg = (res && res.data) || 'No se pudo registrar el abono';
					win.mostrarNotificacion(msg, 'error');
					return;
				}
				const data = res.data || {};
				let msg = data.message || 'Abono registrado';
				if (data.is_completed) {
					msg = 'Crédito saldado completamente';
				} else if (data.remaining != null) {
					msg = `Abono OK. Saldo restante: ${moneyUsd(data.remaining)}`;
				}
				win.mostrarNotificacion(msg, 'success');
				$('#modal-abono-credito').hide();
				win.cargarCreditosPos(($('#creditos-pos-buscar').val() || '').trim());
				if (typeof win.cargarEstadoCaja === 'function') {
					win.setTimeout(() => win.cargarEstadoCaja(), 400);
				}
			})
			.fail(() => {
				win.mostrarNotificacion('Error de conexión al registrar el abono', 'error');
			})
			.always(() => {
				$btn.prop('disabled', false).text('Registrar abono');
			});
	};

	$(() => {
		$(document).on('click', '.credito-pos-abonar-btn', function () {
			win.abrirModalAbonoCredito($(this).data('order-id'));
		});
		$('#creditos-pos-buscar').on('input', function () {
			const q = String($(this).val() || '').trim();
			clearTimeout(win._posknCreditsSearchTimer);
			win._posknCreditsSearchTimer = win.setTimeout(() => win.cargarCreditosPos(q), 280);
		});
		$('#abono-metodo').on('change', () => win.actualizarMonedaAbonoCredito());
		$('#btn-confirmar-abono-credito').on('click', () => win.confirmarAbonoCredito());
	});
}
